/**
 * Phase 8 T-06c §21.B — `Save` vs `Shortlist` semantic (pure helpers).
 *
 * One boolean in thread state drives the emerald action label:
 *   - `null`           → the thread is not attached to a collection yet, so
 *                        the primary action reads `Save →` (offers the
 *                        collections picker).
 *   - `{ id, name }`   → the thread has a target collection; label becomes
 *                        `Shortlist →`.
 *
 * These helpers are isolated here so the UI components stay declarative and
 * the behaviour can be unit-tested without rendering React.
 */

import type { SmartMatchCollectionRef } from './smartMatchThreads';

export type ShortlistActionKind = 'save' | 'shortlist';

export function shortlistActionKindFor(
  collection: SmartMatchCollectionRef | null | undefined,
): ShortlistActionKind {
  return collection ? 'shortlist' : 'save';
}

export function shortlistLabelFor(
  collection: SmartMatchCollectionRef | null | undefined,
): string {
  return shortlistActionKindFor(collection) === 'shortlist' ? 'Shortlist' : 'Save';
}

/**
 * Whether the Shortlist-button click should open the collections picker
 * (§21.E). Picker only opens when there's no collection attached and we're
 * on the Sourcing-style surface.
 */
export function shouldOpenCollectionsPicker(
  collection: SmartMatchCollectionRef | null | undefined,
): boolean {
  return shortlistActionKindFor(collection) === 'save';
}
